module.exports = __webpack_public_path__ + "img/partners_marquee.9edf2432.png";